<span class="badge {{cssClass()}}">{{initials()}}</span>